const oauthClient = require('api/auth')

export const AccessGroupApis = {
  isAuthorized: (role: string, resource_type?: string, resource_id?: string): Promise<{ is_authorized: boolean }> => {
    const token = oauthClient.getAuthResponse() ? oauthClient.getAuthResponse().access_token : null

    return fetch(`${USERS_API_V5}/is_resource_authorized`, {
      method: 'POST',
      headers: authJsonHeaders(token),
      body: JSON.stringify({
        ...(!!resource_type && { resource_type }),
        ...(!!resource_id && { resource_id: String(resource_id) }),
        ...{ role },
      }),
    }).then((res) => (res.ok ? res.json() : res.json().then((data) => Promise.reject(data))))
  },
}

const authJsonHeaders = (token: string): any => {
  return {
    'Content-Type': 'application/json',
    Authorisation: `Bearer ${token}`,
    Authorization: `Bearer ${token}`,
  }
}
